import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    Plus,
    MoreHorizontal,
    Filter,
    PenTool,
    Trophy,
    Calendar as CalendarIcon,
} from 'lucide-react';

export default function Exams() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 8');
    const [selectedDivision, setSelectedDivision] = useState('Division - C');

    const examsData = [
        { id: 1, sn: '01', subject: "Mathematics", examType: "Mid-Term Examination", date: "Feb 10, 2026", hall: "Hall A", status: 'Scheduled' },
        { id: 2, sn: '02', subject: "Physics", examType: "Internal Assessment", date: "Feb 15, 2026", hall: "Hall B", status: 'Scheduled' },
        { id: 3, sn: '03', subject: "Advanced Algebra", examType: "Quarterly Exam", date: "Mar 02, 2026", hall: "Hall C", status: 'Upcoming' },
        { id: 4, sn: '04', subject: "Chemistry", examType: "Mid-Term Examination", date: "Mar 10, 2026", hall: "Hall A", status: 'Upcoming' },
        { id: 5, sn: '05', subject: "Computer Science", examType: "Practical Exam", date: "Mar 15, 2026", hall: "Lab 1", status: 'Upcoming' },
        { id: 6, sn: '06', subject: "English Literature", examType: "Quarterly Exam", date: "Mar 20, 2026", hall: "Hall D", status: 'Upcoming' }
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Examination Hub"
                    subtitle={`Manage schedules and results for ${selectedStandard}`}
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >
                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Schedule Exam
                    </button>
                </Header>

                {/* Main Content Table Card */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">Exam Timetable</h3>
                            <div className="flex items-center gap-2">
                                <span className="w-2.5 h-2.5 bg-rose-500 rounded-full"></span>
                                <span className="text-gray-400 font-bold text-[14px]">06 Exams Planned</span>
                            </div>
                        </div>
                        <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                            <MoreHorizontal size={22} />
                        </button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">S/N</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Subject Details</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Date & Timing</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">Hall / Lab</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">Status</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {examsData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5 text-[14px] font-bold text-gray-500 text-center">{v.sn}</td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center group-hover:bg-blue-500 group-hover:text-white transition-all duration-300">
                                                    <PenTool size={20} />
                                                </div>
                                                <div>
                                                    <p className="text-[15px] font-black text-[#111827] group-hover:text-blue-500 transition-colors leading-tight">{v.subject}</p>
                                                    <p className="text-[12px] font-bold text-gray-400 uppercase tracking-wider">{v.examType}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2.5 text-[14px] font-bold text-gray-700">
                                                <CalendarIcon size={16} className="text-gray-400" />
                                                {v.date}
                                            </div>
                                        </td>
                                        <td className="px-6 py-5 text-[14px] font-black text-[#111827] text-center">
                                            <span className="px-3 py-1 bg-[#F8FAFC] rounded-lg text-gray-600 group-hover:bg-gray-100">{v.hall}</span>
                                        </td>
                                        <td className="px-8 py-5 text-center">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg inline-block text-center uppercase tracking-widest ${v.status === 'Scheduled' ? 'text-blue-500 bg-blue-50/50' :
                                                'text-amber-500 bg-amber-50/50'
                                                }`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-2 text-gray-400 font-bold text-[13px]">
                                                <button className="hover:text-blue-500 transition-colors">Seat Plan</button>
                                                <span className="opacity-30">|</span>
                                                <button className="hover:text-blue-500 transition-colors">Results</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-8 border-t border-gray-50 flex items-center justify-between">
                        <div className="flex items-center gap-2 text-[14px] font-bold text-gray-400">
                            Examination schedule for the upcoming month
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
